import { z } from 'zod';

export const createUserFormValidationSchema = z.object({
  firstName: z.string().min(1, "First name can't be empty"),
  lastName: z.string().min(1, "Last name can't be empty"),
  email: z.string().email(),
});

export type CreateUserFormType = {
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  userPassType: number;
  userCreationType: number;
  platform: string;
  organizationId: string;
  roles: string[];
  permissions: string[];
};

export const createUserFormDefaultvalue = {
  firstName: '',
  lastName: '',
  email: '',
  organizationId: '',
};

export const profileFormValidationSchema = z.object({
  firstName: z.string().min(1, "First name can't be empty"),
  lastName: z.string().min(1, "Last name can't be empty"),
  // email: z.string().email(),
});

export type ProfileFormType = {
  itemId: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  /** How Buddy addresses the user; optional on older accounts. */
  salutation?: string;
  phoneNumber?: string;
  profileImageUrl?: string;
  organizationId?: string;
  organizationIds?: string[];
  roles?: string[];
  permissions?: string[];
  OrganizationsRoles?: Record<string, string[]>;
  OrganizationsPermissions?: Record<string, string[]>;
  memberships?: Array<{
    organizationId: string;
    roles?: string[];
    permissions?: string[];
  }>;
};

/** Builds IAM profile update payload aligned with Blocks OS (roles ≠ permissions). */
export const buildIamProfileUpdatePayload = ({
  itemId,
  firstName,
  lastName,
  email,
  phoneNumber,
  country,
  scopedRoles,
  organizationIds,
  primaryOrgId,
  existingOrgRoles = {},
  existingOrgPermissions = {},
}: {
  itemId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  country: string;
  scopedRoles: string[];
  organizationIds: string[];
  primaryOrgId: string;
  existingOrgRoles?: Record<string, string[]>;
  existingOrgPermissions?: Record<string, string[]>;
}): ProfileFormType & { userId: string } => ({
  itemId,
  firstName,
  lastName,
  email,
  phoneNumber,
  country,
  organizationIds,
  roles: scopedRoles,
  permissions: [],
  OrganizationsRoles: {
    ...existingOrgRoles,
    [primaryOrgId]: scopedRoles,
  },
  OrganizationsPermissions: {
    ...existingOrgPermissions,
    [primaryOrgId]: [],
  },
  userId: itemId,
});

export const haveRolesChanged = (nextRoles: string[], previousRoles: string[]) =>
  nextRoles.length !== previousRoles.length ||
  nextRoles.some((role) => !previousRoles.includes(role));

export const profileFormDefaultvalue = {
  itemId: '',
  firstName: '',
  lastName: '',
  email: '',
  country: '',
};

export const changePasswordFormValidationSchema = z.object({
  oldPassword: z.string().min(1, "Current password can't be empty"),
  newPassword: z.string().min(8, 'Password must be at least 8 character long'),
  confirmNewPassword: z.string().min(8, 'Password must be at least 8 character long'),
});

export type changePasswordFormType = z.infer<typeof changePasswordFormValidationSchema>;

export const changePasswordFormDefaultValue: changePasswordFormType = {
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: '',
};
